export const scrollToCommentInDoc = (id: string): void => {
  document
    .querySelector(`.ck [data-commentid="rl-comment-${id}"]`)
    ?.scrollIntoView({ behavior: 'smooth', block: 'center' });
};
